module.exports = __webpack_public_path__ + "img/uav30x30.61601bc2.png";